/**
 * @file: useCreateOrderRequest.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCurrentUserDangerously } from '@euler/app/flows/auth/context';
import { CreateChildOrderRequest } from '@euler/model';
import { OrderSourceType } from '@euler/model/enum';
import { normalizedOrderTags } from '@euler/utils';
import { formatDateTime } from '@euler/utils/formatters';
import { useBehaviorSubject, usePersistFn } from '@euler/utils/hooks';
import { useOrderFlowContext } from '../OrderFlowContext';

export function useCreateChildOrderRequest() {
  const {
    formController: { form },
    orderDetail$,
  } = useOrderFlowContext();
  const [detail] = useBehaviorSubject(orderDetail$);
  const user = useCurrentUserDangerously();

  return usePersistFn((): CreateChildOrderRequest => {
    return {
      tags: normalizedOrderTags(form.tags.value?.join(',') ?? ''),
      source: {
        type: OrderSourceType.Default,
        serviceAgentId: form.serviceAgentInfo.value?.serviceAgentId ?? 0,
        serviceAgentName: form.serviceAgentInfo.value?.name ?? '',
        requestMemberId: user.user.memberId,
      },
      estimatedFinishTime: form.estimatedFinishTime.value
        ? formatDateTime(form.estimatedFinishTime.value, 'yyyy-MM-dd HH:mm:ss')
        : undefined,
      remark: form.remark.value,
      detail: {
        serviceSubjects: detail.serviceSubjects,
      },
    };
  });
}
